import { ProductLabel, breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const StyledLabel = styled(ProductLabel)`
  @media (max-width: ${breakpoints.sm}) {
    font-size: 0.75rem !important;
  }

  // for corner tag
  top: 0px;
  right: 0px;

  text-transform: none;
  ${theme.typography.labelSmall}
`;

export const LabelsContainer = styled.div<{ noWrapLg: boolean }>`
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${breakpoints.lg}) {
    flex-wrap: ${(props) => (props.noWrapLg ? 'nowrap' : 'wrap')};
  }
`;

export const LabelWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;
